module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CurrencyTypeList'
      }
    }
  }, [_vm._v("Waluty")]), _vm._v("/"), (_vm.item && !_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.item['name']))]) : _vm._e()], 1), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'CurrencyTypeUpdate',
        params: {
          id: _vm.item.id
        }
      },
      "title": "Edytuj"
    }
  }, [_c('span', [_vm._v("Edytuj")]), _c('svg-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Nazwa")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['name']))])])])])])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-024740a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/currencytype/Show.vue
// module id = 774
// module chunks = 0